import { render, staticRenderFns } from "./SECFilingsComponent.vue?vue&type=template&id=3b6c57e0&scoped=true&"
import script from "./SECFilingsComponent.vue?vue&type=script&lang=js&"
export * from "./SECFilingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c57e0",
  null
  
)

export default component.exports